import { createContext } from 'react';

type Unregister = () => void;
type Register = (onEscCallback: () => void) => Unregister;
type ModalsContext = {
  register: Register;
};

export default createContext({} as ModalsContext);